import React, { ReactNode } from 'react';

import { IconVariant, Pressable, Typography } from '@rbilabs/universal-components';
import { Icon } from '@rbilabs/universal-components';
import { StyleSheet, View } from 'react-native';

import { getDesignToken, primitive, spacing } from 'styles/constants';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

const StyledBackIcon = Icon.withConfig({
  color: getDesignToken('icon-header-contrast'),
  size: '5',
  ...hiddenAccessibilityPlatformProps,
});

export type HeaderProps = {
  title: string;
  closeIconVariant?: IconVariant;
  closeIconPosition?: 'left' | 'right';
  variant?: 'light' | 'dark' | 'transparent';
  children?: ReactNode;
  onCloseIconClick: () => void;
};

const colorSchemes = {
  dark: {
    text: primitive.$white,
    background: primitive.$bbqBrown,
  },
  light: {
    text: primitive.$bbqBrown,
    background: primitive.$mayoEggWhite,
  },
  transparent: {
    text: primitive.$bbqBrown,
    background: 'transparent',
  },
} as const;

export function Header({
  title,
  closeIconVariant,
  closeIconPosition,
  variant = 'dark',
  children,
  onCloseIconClick,
}: HeaderProps) {
  const colors = colorSchemes[variant] ?? colorSchemes.dark;
  const textAndIconColor = colors.text;
  const headerColor = colors.background;

  return (
    <>
      <View
        style={[
          styles.headerContainer,
          {
            backgroundColor: headerColor,
          },
        ]}
      >
        {children ? (
          children
        ) : (
          <Typography
            accessibilityRole="header"
            accessibilityLevel={2}
            color={textAndIconColor}
            style={styles.headerText}
          >
            {title}
          </Typography>
        )}
        {!children && (
          <View
            style={[
              styles.iconContainer,
              closeIconPosition === 'left' ? { left: spacing.$3 } : { right: spacing.$3 },
            ]}
          >
            <Pressable onPress={onCloseIconClick}>
              <StyledBackIcon variant={closeIconVariant || 'cancel'} color={textAndIconColor} />
            </Pressable>
          </View>
        )}
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  headerContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    height: 56,
  },
  headerText: {
    fontFamily: primitive.fontFamily.$headers,
    fontSize: 20,
    letterSpacing: -0.42,
  },
  iconContainer: {
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
